import { createSelector } from '@ngrx/store';
import { getPaceFormsState } from './pace-forms.selector';

export const getDocBoxSelector = createSelector(getPaceFormsState, (state) => state.docBox);
export const getDocBoxFilesSelector = createSelector(getDocBoxSelector, (docBoxState) => docBoxState.docBoxFiles);
export const enableDownloadSelector = createSelector(getDocBoxSelector, (state) =>
    state.docBoxFiles.some((file) => file.isFileSelected),
);
export const selectedDocumentsSelector = createSelector(getDocBoxSelector, (state) =>
    state.docBoxFiles.reduce((docBoxIds, file) => {
        if (file.isFileSelected) {
            docBoxIds.push(file.docBoxId);
        }
        return docBoxIds;
    }, new Array<string>()),
);
